<template>
  <div class="settle-accounts-detail">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            基本信息
          </div>
        </template>
        <div class="collapse-content">
          <SiruiSearch
            ref="baseInfoFormRef"
            :query="baseFormData"
            :columns="formColumn"
            :isQueryPanel="false"
            :rules="baseFormRules"
            labelWidth="170px"
            @changeCompanyHandler="changeCompanyHandler"
            @changeDepartmentHandler="changeDepartmentHandler"
            @changeCurrencyHandler="changeCurrencyHandler"
          ></SiruiSearch>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            结算行
          </div>
        </template>
        <div class="collapse-content">
          <SettleAccountsRow
            ref="linesRef"
            @selectionRowHandler="selectionRowHandler"
            @closeEditTableHandler="closeRowEditTableHandler"
            @deleteTableHandler="deleteTableRowHandler"
            :baseFormData="baseFormData"
            :productList="productList"
            :isCreate="isCreate"
            :currentDetailData="currentDetailData"
            :settleAccountsDetailMap="settleAccountsDetailMap"
            @importData="importDataHandler"
            :linesData="detailData.lines ? detailData.lines : []"
            @getProductList="_getContractProduct"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="3" v-if="currentSettleAccountRowData">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            结算明细
          </div>
        </template>
        <div class="collapse-content">
          <SettleAccountsInfo
            ref="lineDetails"
            :isCreate="isCreate"
            @closeEditTableHandler="closeDetailEditTableHandler"
            :tableDataList="currentSettleAccountDetailList"
            @deleteTableHandler="deleteTableDetailHandler"
            @saveDeleteLineDetailIds="saveDeleteLineDetailIds"
            :baseFormData="baseFormData"
            :productList="productList"
            :currentSettleAccountRowData="currentSettleAccountRowData"
            @importData="importDataHandler"
            @_formatSettleAccountDto="_formatSettleAccountDto"
            :lineDetailsList="lineDetailsList"
          />
        </div> </el-collapse-item
      ><el-collapse-item name="4" v-if="deductions.length > 0">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            抵扣信息
          </div>
        </template>
        <div class="collapse-content">
          <DeductionRow
            ref="DeductionRow"
            :isCreate="isCreate"
            :deductionList="deductions"
            @deleteDeductTableHandler="deleteDeductTableHandler"
            @closeEditDeductTableRowHandler="closeEditDeductTableRowHandler"
            @saveDeleteDeductionId="saveDeleteDeductionId"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="5" v-if="preSettlements.length > 0">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            关联预结算
          </div>
        </template>
        <div class="collapse-content">
          <RelatedRow
            ref="relatedRow"
            :isCreate="isCreate"
            :preSettlements="preSettlements"
            @deleteTableHandler="deleteRelatedTableHandler"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="6" v-if="advancePayments.length > 0">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            关联预付款
          </div>
        </template>
        <div class="collapse-content">
          <PayRow
            ref="payRow"
            :isCreate="isCreate"
            :preSettlements="advancePayments"
            @deleteTableHandler="deletePayTableHandler"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="7" v-if="payeeInfoData.length > 0">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            付款信息
          </div>
        </template>
        <div class="collapse-content">
          <PayeeInfo style="margin-top: 10px" :payeeInfoData="payeeInfoData" />
        </div>
      </el-collapse-item>
      <el-collapse-item name="8">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            附件上传
          </div>
        </template>
        <div class="collapse-content">
          <FileTable
            ref="fileTableRef"
            :attachments="detailData.attachments"
            :isShowDownBtn="!isCreate"
          />
        </div>
      </el-collapse-item>
      <!-- <el-collapse-item name="7">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            抵扣信息
          </div>
        </template>
      </el-collapse-item> -->
    </el-collapse>
    <RelatedSettlement
      ref="relatedSettlementRef"
      @relatedHandler="relatedHandler"
    ></RelatedSettlement>
    <DeductionDialog
      ref="deductionDialogRef"
      @deductionDialogHandler="deductionDialogHandler"
    ></DeductionDialog>
    <PayDialog ref="payDialogRef" @deductionDialogHandler="payDialogHandler"></PayDialog>
    <div class="btn-group">
      <el-button v-if="isCreate" type="primary" key="666" @click="_saveHandler()"> 保存 </el-button>
      <el-button v-if="isCreate" type="primary" key="777" @click="_btnDeductionHandler()">
        抵扣
      </el-button>
      <el-button v-if="isCreate" type="primary" key="7777" @click="_btnPayHandler()">
        关联预付款
      </el-button>
      <el-button v-if="isCreate" type="primary" key="888" @click="_saveHandler(1)">
        提交审批
      </el-button>
      <el-button
        v-if="
          ['detail'].includes(this.currentStatus) &&
          ['01', '03', '05'].includes(this.statementStatus) &&
          !isCreate
        "
        type="primary"
        key="999"
        @click="isCreate = true"
      >
        编辑
      </el-button>
      <el-button
        v-if="
          ['detail'].includes(this.currentStatus) &&
          ['06'].includes(this.statementStatus) &&
          payeeInfoData.length < 1 &&
          !isCreate
        "
        type="primary"
        key="666"
        @click="isCreate = true"
      >
        调整
      </el-button>
      <el-button
        type="primary"
        v-for="(item, index) of btnList"
        :key="index"
        @click="btnClickHandler(item.type)"
        >{{ item.title }}</el-button
      >
      <el-button
        v-if="relatedStatus && isCreate"
        type="primary"
        key="999"
        @click="btnRelatedHandler()"
      >
        关联预结算
      </el-button>
      <el-button
        v-if="
          ['detail'].includes(this.currentStatus) &&
          ['02'].includes(this.statementStatus) &&
          payeeInfoData.length < 1 &&
          !isCreate
        "
        type="primary"
        key="999"
        @click="withdrawApprovalHandler"
      >
        撤回审批
      </el-button>
    </div>
    <Print ref="easyPrint">
      <PrintDemo :content="content" />
    </Print>
    <PrintDialog ref="PrintDialog" @printHandler="DetailPrintHandler"></PrintDialog>
  </div>
</template>
<script>
  import { formatDate } from '@/utils';
  import SettleAccountsRow from './components/SettleAccountsRow/index.vue';
  import SettleAccountsInfo from './components/SettleAccountsInfo/index.vue';
  import DeductionRow from './components/DeductionRow/index.vue';
  import PayeeInfo from './components/PayeeInfo/index.vue';
  import RelatedRow from './components/RelatedRow/index.vue';
  // import API_base from '@/api/dataBase';
  // import FileTable from './components/FileTable/index.vue';
  import DeductionDialog from './components/DeductionDialog/index.vue';
  import RelatedSettlement from './components/RelatedSettlement/index.vue';
  import baseInfoMixin from './components/BaseInfo/index.js';
  import PAYABLES_TRADE from '@/api/receivablesAndPayables/trade.js';
  // import { tableList } from './components/RelatedSettlement/index.js';
  import Print from '@/components/Print';
  import PrintDemo from '@/components/Print/printDemo';
  import PrintDialog from '../../../../components/PrintDialog.vue';
  import SALE_API from '@/api/purchaseSalesCenter/purchaseSales.js';
  import PayRow from './components/PayRow/index.vue';
  import PayDialog from './components/PayDialog/index.vue';
  import XEUtils from 'xe-utils';
  import Big from 'big.js';
  import wumaoMixins from '@/common/mixins/wumaoMixins';
  export default {
    name: 'chengkuangPayablesCreate',
    mixins: [baseInfoMixin, wumaoMixins],
    data() {
      return {
        content: '',
        activeNames: ['1', '2', '3', '4', '5', '6'],
        currentStatus: '',
        statementStatus: '', // 结算单状态
        statePaymentStatus: '', // 付款状态
        stateSettlementTypeStatus: '', //结算单类型
        // baseFormData: {},
        currentSettleAccountRowData: null, // 当前选中的行数据
        settleAccountsRowList: [], // 全部的行数据
        settleAccountsDetailMap: new Map(), // key为结算行的id,值为结算明细数组
        currentSettleAccountDetailList: [], //明细表数据
        currentDetailData: {}, // 当前结算明细数据
        detailData: {}, // 根据结算单号查询出来的数据
        payeeInfoData: [], //根据结算单号查询出来的付款信息
        relatedStatus: true, //控制关联预结算按钮是否显示
        preSettlements: [], //结算单号查询出来关联预结算信息
        copyPreSettlements: [], //用于编辑时对比删除了哪些关联预结算单,
        deductions: [], //抵扣行信息
        deleteDeductionId: null, //删除的抵扣行id 编辑时用
        deductionDetails: [], //勾选的抵扣详细内容
        noLineDetails: false, //判断每个结算行至少要对应一个结算明细
        settlementIndex: '', //具体是哪个结算行没有结算明细  序号
        contractNos: [], //多个合同编号集合
        advancePayments: [], //结算单号查询出来关联预付款信息
        copyAdvancePayments: [], //用于编辑时对比删除了哪些关联预付款,
        copyPaidAmount: '0', //用于记录已付款金额 后续重新选择合同有用
        deleteLineDetailIds: [],
        lineDetailsList: [], //所有的明细行数据
        supplyDetailsPdf: {},
        supplyDetailsAttachments: [],
        supplyDetailsXlsx: {},
      };
    },
    methods: {
      // 撤回审批中
      withdrawApprovalHandler() {
        this.loading.startLoading();
        this.$axios
          .post('/financial/payableSettlement/withdrawOA', {
            businessGroup: this.userInfo.businessGroup,
            ids: [this.$route.query.id],
            oaId: this.userInfo.oaId,
          })
          .then((res) => {
            this.loading.endLoading();
            const { code, msg } = res.data;
            if (code == 0) {
              this.$message.success('撤回成功');
              this.$router.go(-1);
            } else {
              this.$message.error(msg);
            }
          })
          .catch(() => {
            this.loading.endLoading();
          });
      },
      saveDeleteLineDetailIds(val) {
        this.deleteLineDetailIds = val;
      },
      saveDeleteDeductionId(val) {
        this.deleteDeductionId = val || this.deleteDeductionId;
      },
      // 结算行单机一行数据
      selectionRowHandler(rowData) {
        this.currentSettleAccountRowData = rowData;
        //涉及到详情编辑的时候回显明细行
        // let lineDetails = rowData.lineDetails ? rowData.lineDetails : [];
        if (rowData) {
          const currentSettleAccountDetailList = this.settleAccountsDetailMap.get(rowData._XID);
          this.currentSettleAccountDetailList = currentSettleAccountDetailList
            ? currentSettleAccountDetailList
            : [];
        }

        // console.log(
        //   currentSettleAccountDetailList,
        //   '--选择行切换数据',
        //   this.settleAccountsDetailMap
        // );
      },
      // 关闭行编辑的时候
      closeRowEditTableHandler(tableData, isFetchData = false) {
        if (!tableData.length) return;
        this.settleAccountsRowList = tableData;
        if (!isFetchData) {
          // 计算原币结算金额和本币计算金额
          this._computeRowTableTotalAmount(tableData);
        } else {
          // 把当前表格里面的lineDetails设置到map中
          for (const item of tableData) {
            console.log('进来了', item);
            // 找到当前项的lineDetails
            let currentItem = this.detailData.lines.find((it) => it.id == item.id);
            const lineDetails = currentItem?.lineDetails ? currentItem?.lineDetails : [];
            console.log('lineDetails', lineDetails);
            this.settleAccountsDetailMap.set(item._XID, lineDetails);
            console.log('this.settleAccountsDetailMap', this.settleAccountsDetailMap);
          }
        }
      },
      // 展示pdf
      showPdf() {
        console.log(this.supplyDetailsAttachments);
        // this.$refs.fileTableRef.$refs.viewFileRef.openViewHandler(this.supplyDetailsPdf);
      },
      // 关闭明细表的时候
      closeDetailEditTableHandler(tableData) {
        this.settleAccountsDetailMap.set(this.currentSettleAccountRowData._XID, tableData);
        console.log(this.settleAccountsDetailMap, '明细中', this.currentSettleAccountRowData._XID);
        this.currentSettleAccountDetailList = tableData;
        this._computedDetailTableTotalAmount(tableData);
      },
      // 删除结算行
      deleteTableRowHandler(rowIdList, tableData) {
        let currentSettleAccountDetailList = this.settleAccountsDetailMap.get(rowIdList[0]) || [];
        let paidAmountTotal = 0;
        currentSettleAccountDetailList.map((item) => {
          paidAmountTotal += +item['paidAmount'] || 0;
        });
        console.log(rowIdList, '删除行', this.settleAccountsRowList);

        this.settleAccountsRowList = this.settleAccountsRowList.filter(
          (item) => !rowIdList.includes(item._XID)
        );
        let contractNoList = tableData.map((item) => item.contractNo);
        let supplierNoList = tableData.map((item) => item.supplierNo);
        let isMoreDeliverer = [...new Set(supplierNoList)].length > 1 ? '1' : '0';
        let supplierNo = [...new Set(supplierNoList)].join(',');
        let supplierNameList = tableData.map((item) => item.supplierName);
        let supplierName = [...new Set(supplierNameList)].join(',');
        let contractNo = [...new Set(contractNoList)].join(','); // 合同,

        let amount = this.baseFormData.paidAmount - +paidAmountTotal;
        if (isNaN(amount)) {
          amount = 0;
        }
        this.baseFormData = {
          ...this.baseFormData,
          isMoreDeliverer,
          supplierNo,
          supplierName,
          contractNo,
          paidAmount: amount + '',
        };

        // 计算金额
        this._computeRowTableTotalAmount(tableData);
      },
      // 导入明细表数据
      importDataHandler(importData) {
        console.log(importData, '导入明细表');
        const { currencyCode, currencyName, exchangeRate } = this.baseFormData;
        // this.importData = data;
        const detailData = importData.map((item) => {
          return {
            ...item,
            currencyCode: item.currencyCode || currencyCode,
            currencyName: item.currencyName || currencyName,
            exchangeRate: item.exchangeRate || exchangeRate,
            businessDocNo: item.businessDocCode,
            settlementQuantity: item.statementQuantity,
            originalAmountWithoutTax: (
              item.originalAmount /
              (1 + +(item.taxRate ? item.taxRate : 0))
            ).toFixed(2),
            originalTaxAmount: (
              item.originalAmount -
              item.originalAmount / (1 + +(item.taxRate ? item.taxRate : 0))
            ).toFixed(2),
            domesticAmountWithoutTax: (
              (item.originalAmount / (1 + +(item.taxRate ? item.taxRate : 0))) *
              item.exchangeRate
            ).toFixed(2),
            domesticTaxAmount: (
              item.domesticAmount -
              (item.originalAmount / (1 + +(item.taxRate ? item.taxRate : 0))) * item.exchangeRate
            ).toFixed(2),
            // productCode: item.contractDetailInfo.productNo,
            // productName: item.contractDetailInfo.productDesc,
          };
        });
        this.resyncLineDetailAndLines(detailData);
        // this.currentSettleAccountDetailList = currentSettleAccountDetailList
        //   ? currentSettleAccountDetailList.concat(detailData)
        //   : [].concat(detailData);
        // this.settleAccountsDetailMap.set(
        //   this.currentSettleAccountRowData._XID,
        //   this.currentSettleAccountDetailList
        // );
        // let newList = [];
        // // if (currentSettleAccountDetailList && currentSettleAccountDetailList?.length) {
        // //   let ids = currentSettleAccountDetailList.map((item) => item.id);
        // //   newList = detailData.filter((item) => !ids.includes(item.id));
        // // } else {
        // //   newList = detailData;
        // // }
        // let lines = this._formatSettleAccountDto();
        // if (lines && lines.length) {
        //   if (this.lineDetailsList && this.lineDetailsList?.length) {
        //     let ids = this.lineDetailsList.map((item) => item.id);
        //     newList = detailData.filter((item) => !ids.includes(item.id));
        //   } else {
        //     newList = detailData;
        //   }
        //   console.log(newList, 'newListnewListnewListnewList');
        //   if (newList && newList.length) {
        //     let paidAmountTotal = 0;
        //     newList.map((item) => {
        //       paidAmountTotal += +item['paidAmount'] || 0;
        //     });
        //     if (isNaN(paidAmountTotal)) {
        //       paidAmountTotal = 0;
        //     }
        //     if (isNaN(this.baseFormData.paidAmount)) {
        //       this.baseFormData.paidAmount = 0;
        //     }
        //     this.baseFormData.paidAmount =
        //       (Number(this.baseFormData.paidAmount) + Number(paidAmountTotal)).toFixed(2) + '';
        //   }
        //   this.currentSettleAccountDetailList = currentSettleAccountDetailList
        //     ? currentSettleAccountDetailList.concat(newList)
        //     : [].concat(newList);
        //   this.settleAccountsDetailMap.set(
        //     this.currentSettleAccountRowData._XID,
        //     this.currentSettleAccountDetailList
        //   );
        //   // 处理下反填到数据结算表中
        //   this._computedDetailTableTotalAmount(this.currentSettleAccountDetailList);
        //   // 处理好反填到表单上
        //   this._computeRowTableTotalAmount(this.settleAccountsRowList);
        // }
      },
      resyncLineDetailAndLines(detailData) {
        const currentSettleAccountDetailList = this.settleAccountsDetailMap.get(
          this.currentSettleAccountRowData._XID
        );
        let newList = [];
        let lines = this._formatSettleAccountDto();
        if (lines && lines.length) {
          if (this.lineDetailsList && this.lineDetailsList?.length) {
            let ids = this.lineDetailsList.map((item) => item.id);
            newList = detailData.filter((item) => !ids.includes(item.id));
          } else {
            newList = detailData;
          }
          console.log(newList, 'newListnewListnewListnewList');
          if (newList && newList.length) {
            let paidAmountTotal = 0;
            newList.map((item) => {
              paidAmountTotal += +item['paidAmount'] || 0;
            });
            if (isNaN(paidAmountTotal)) {
              paidAmountTotal = 0;
            }
            if (isNaN(this.baseFormData.paidAmount)) {
              this.baseFormData.paidAmount = 0;
            }
            this.baseFormData.paidAmount =
              (Number(this.baseFormData.paidAmount) + Number(paidAmountTotal)).toFixed(2) + '';
          }
          this.currentSettleAccountDetailList = currentSettleAccountDetailList
            ? currentSettleAccountDetailList.concat(newList)
            : [].concat(newList);
          this.settleAccountsDetailMap.set(
            this.currentSettleAccountRowData._XID,
            this.currentSettleAccountDetailList
          );
          // 处理下反填到数据结算表中
          this._computedDetailTableTotalAmount(this.currentSettleAccountDetailList);
          // 处理好反填到表单上
          this._computeRowTableTotalAmount(this.settleAccountsRowList);
        }
      },
      // 删除明细行
      deleteTableDetailHandler(rowIdList, paidAmountTotal) {
        console.log(rowIdList, '删除明细', this.settleAccountsDetailMap);
        // 获取当当前数组项目
        const detailListItem = this.settleAccountsDetailMap.get(
          this.currentSettleAccountRowData._XID
        );
        console.log(detailListItem, '删除前');
        // 删除子项
        let newData;
        if (detailListItem && detailListItem.length) {
          newData = detailListItem.filter((item) => !rowIdList.includes(item._XID));
        }
        this.currentSettleAccountDetailList = this.currentSettleAccountDetailList.filter(
          (item) => !rowIdList.includes(item._XID)
        );
        console.log(newData, '???删除后');
        this.settleAccountsDetailMap.set(this.currentSettleAccountRowData._XID, newData);
        console.log(
          this.settleAccountsDetailMap.get(this.currentSettleAccountRowData._XID),
          '查看存入值'
        );
        this.baseFormData.paidAmount = this.baseFormData.paidAmount - +paidAmountTotal + '';

        if (isNaN(this.baseFormData.paidAmount) && this.baseFormData.paidAmount) {
          this.baseFormData.paidAmount = 0;
        } else {
          if (this.baseFormData.paidAmount != 0) {
            this.baseFormData.paidAmount = this.baseFormData.paidAmount.toFixed(2) + '';
          }
        }
        // 处理下反填到数据结算表中
        // this._computedDetailTableTotalAmount(newData);
        this.resyncLineDetailAndLines(newData);
      },
      // 点击按钮组
      btnClickHandler(type) {
        if (type === 'save') {
          this._saveHandler();
        } else if (type === 'edit') {
          this.isCreate = true;
        } else if (type === 'approval') {
          this._saveHandler(1);
        } else if (type === 'payApplication') {
          this._payApplicationHandler();
        } else if (type === 'resize') {
          this.isCreate = true;
        } else if (type === 'cancel') {
          this.withdrawHandler();
        } else if (type === 'settlementLock') {
          this._settlementLockHandler();
        } else if (type === 'close') {
          this.closeSettleAccountsHandler();
        } else if (type === 'print') {
          this.printHandler();
        } else if (type === 'deduction') {
          console.log('抵扣');
          this._btnDeductionHandler();
        }
        console.log(type, '点击按钮');
      },

      //打印
      printHandler() {
        this.$refs.PrintDialog.openDialog();
        console.log('打印');
      },
      DetailPrintHandler(val) {
        this.loading.startLoading();
        const params = {
          id: +this.$route.query?.id,
          downloadOrPrint: 'print',
        };
        this.$axios.post(PAYABLES_TRADE.PAYABLELIST_PRINT, params).then((res) => {
          this.loading.endLoading();
          if (res.data.code === 0) {
            if (val == 'pdf') {
              window.open(res.data.data.pdf, '_blank');
            }
            if (val == 'excel') {
              window.open(res.data.data.word, '_blank');
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
      },
      //关闭
      async closeSettleAccountsHandler() {
        this.$confirm('确定要关闭吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let postData = [+this.$route.query?.id];
            const { data } = await this.$axios.post(PAYABLES_TRADE.PAYABLELIST_CLOSE, postData);
            if (data.code === 0) {
              this.$message.success('关闭成功');
              this.$router.go(-1);
            } else {
              this.$message.error(`${data.msg}`);
            }
          })
          .catch(() => {});
      },
      //锁定
      async _settlementLockHandler() {
        if (this.baseFormData.payPayableSettlementNo) {
          this.$message.error('该预结算单已被终结算单关联,不能发起锁定操作!');
          return;
        }
        this.$confirm('确定要锁定吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let postData = [+this.$route.query?.id];
            const { data } = await this.$axios.post(PAYABLES_TRADE.PAYABLELIST_LOCK, postData);
            if (data.code === 0) {
              this.$message.success('锁定成功');
              this.$router.go(-1);
            } else {
              this.$message.error(`${data.msg}`);
            }
          })
          .catch(() => {});
      },
      //撤回
      async withdrawHandler() {
        if (this.baseFormData.payPayableSettlementNo) {
          this.$message.error('该预结算单已被终结算单关联,不能发起撤回操作!');
          return;
        }
        this.$confirm('确定要撤回吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let postData = [+this.$route.query?.id];
            const { data } = await this.$axios.post(PAYABLES_TRADE.PAYBLES_WITHDRAW_API, postData);
            if (data.code === 0) {
              this.$message.success('撤回成功');
              this.$router.go(-1);
            } else {
              this.$message.error(`${data.msg}`);
            }
          })
          .catch(() => {});
      },
      //付款申请
      async _payApplicationHandler() {
        if (this.baseFormData.payPayableSettlementNo) {
          this.$message.error(
            `该预结算单已被终结算单：${this.baseFormData.payPayableSettlementNo}关联,不能发起付款申请!`
          );
          return;
        }
        if (this.baseFormData.originalTotalAmount == '0') {
          this.$message.error('该预结算单原币结算金额(含税)为0,不能发起付款申请!');
          return;
        }
        let postData = {
          id: this.$route.query?.id,
          settlementBusinessType: this.baseFormData.settlementBusinessType,
          businessGroup: this.userInfo.businessGroup,
        };
        // let postData = { id: 41 };
        const { data } = await this.$axios.post(
          PAYABLES_TRADE.PAYBLES_PAYMENTAPPLICATION_API,
          postData
        );
        if (data.code == 0) {
          let passData = data.data;

          // // 上传文件表格
          // let fileTable = this.$refs.fileTableRef.getTableData();
          // if (fileTable && fileTable.length > 0) {
          //   fileTable = fileTable.filter(
          //     (item) => !(item.specialFile && item.specialFile == 'special')
          //   );
          // }
          // passData.attachments = fileTable;

          let path = {
            path: '/payment/applyAddCK',
            name: 'applyAddCK',
            meta: {
              keepAlive: true,
              title: '付款申请单创建',
            },
            query: { isEdit: 'Y', businessType: this.baseFormData.settlementBusinessType },
            params: passData,
          };
          console.log('开票申请', this.baseFormData.settlementBusinessType);
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        } else {
          if (data.msg) {
            return this.$message.error(data.msg);
          }
          this.$message('付款申请失败');
        }
      },
      // 保存接口  type 0-保存,1-提交
      _saveHandler(type = 0) {
        console.log(this._formatSettleAccountDto(), '表格提交数据', this.settleAccountsDetailMap);
        // 1.获取到基本信息数据
        this.$refs.baseInfoFormRef.validate(async (valid, baseInfoData) => {
          this.noLineDetails = false; //判断每个结算行至少要对应一个结算明细
          this.settlementIndex = '';
          if (!valid) {
            this.$message.error('请检查填写信息');
            return;
          }
          let checkLinesRefStatus = await this.$refs?.linesRef?.validAllEvent();
          if (checkLinesRefStatus) {
            return;
          }
          let checkLineDetailsStatus = await this.$refs?.lineDetails?.validAllEvent();
          if (checkLineDetailsStatus) {
            return;
          }
          await this.$refs?.DeductionRow?.closeEditTableHandler();
          let checkDeductionRowStatus = await this.$refs?.DeductionRow?.validAllEvent();
          if (checkDeductionRowStatus) {
            return;
          }

          //校验明细行中合计的抵扣金额原币（含税）是否与抵扣信息中抵扣金额原币（含税）一致
          if (
            this.countLineDetaisDeductAll() > 0 &&
            this.deductions[0]?.deductionOriginalAmount != this.countLineDetaisDeductAll()
          ) {
            this.$message.error(
              '明细行中合计的抵扣金额原币（含税）需与抵扣信息中抵扣金额原币（含税）一致'
            );
            return;
          }
          //判断结算行中如果原币结算单价(含税)、结算数量以及明细行为空 时报错
          // if (this.checkFalse()) {
          //   this.$message.error('结算行中原币结算单价（含税）和结算数量为必填项');
          //   return;
          // }
          if (this._formatSettleAccountDto().length < 1) {
            this.$message.error('结算行不能为空！');
            return;
          }
          //判断每个结算行至少要对应一个结算明细
          if (this.noLineDetails) {
            this.$message.error(`请填写第${this.settlementIndex}行结算行的结算明细`);
            return;
          }
          if (type == 1) {
            try {
              await this.checkCompanyAndDepartment(
                this.baseFormData.settlementCompanyNo,
                this.baseFormData.settlementDepartmentNo
              );
            } catch {
              return;
            }
          }
          this.loading.startLoading();
          // 上传文件表格
          let fileTable = this.$refs.fileTableRef.getTableData();
          if (fileTable && fileTable.length > 0) {
            fileTable = fileTable.filter(
              (item) => !(item.specialFile && item.specialFile == 'special')
            );
          }
          //删除的行ids
          let deleteLineIds = this.$refs?.linesRef.deleteLineIds
            ? this.$refs?.linesRef.deleteLineIds
            : [];
          //删除的明细表ids
          let deleteLineDetailIds =
            this.$refs?.lineDetails?.deleteLineDetailIds.length > 0
              ? this.$refs?.lineDetails?.deleteLineDetailIds
              : this.deleteLineDetailIds;
          //抵扣信息
          let deductions = this.deductions;
          //删除的抵扣行id 编辑时用
          let deleteDeductionId = this.deleteDeductionId;
          //勾选的抵扣详细内容
          let deductionDetails = this.deductionDetails;
          let postData = {
            ...baseInfoData,
            type,
            printFlag: baseInfoData.printFlag && baseInfoData.printFlag == '1' ? 1 : 0,
            oaId: JSON.parse(localStorage.getItem('userInfo')).userInfo.oaId,
            companyName: JSON.parse(localStorage.getItem('userInfo')).userInfo.companyName,
            businessGroup: JSON.parse(localStorage.getItem('userInfo')).userInfo.businessGroup,
            anotherPayFlag: baseInfoData.anotherPayFlag ? 1 : 0,
            payableAccountPeriod: XEUtils.toDateString(
              baseInfoData.payableAccountPeriod,
              'yyyy-MM'
            ),
            lines: this._formatSettleAccountDto(),
            attachments: fileTable,
            deleteLineDetailIds,
            deleteLineIds,
            preSettlements: this.preSettlements,
            deletePre: this.rememberDeleteRelatedIds(),
            advancePayments: this.advancePayments,
            deleteAdvanceIds: this.rememberDeletePayIds(),
            deductions,
            deleteDeductionId,
            deductionDetails,
          };
          if (['edit', 'detail'].includes(this.$route.query?.status)) {
            postData.id = this.$route.query?.id;
          }
          const { data } = await this.$axios.post(
            PAYABLES_TRADE.CREATE_OR_EDIT_TRADE_PAYABLES_API,
            postData
          );
          // const { data } = await this.$axios.post(
          //   'http://10.173.92.58:8020/payableSettlement/save',
          //   postData
          // );
          console.log(data, '保存结果');
          if (data.code === 0) {
            this.loading.endLoading();
            this.$message.success(data.msg);
            // this.$router.go(-1);
            this.closeTab();
          } else {
            this.loading.endLoading();
            this.$message.error(data.msg);
          }
        });
      },
      closeTab() {
        // 关闭当前tab导航
        this.$store.dispatch('tagsView/delView', {
          path: '/receivablesAndPayables/tradePayablesDetail',
          name: 'tradePayablesDetail',
          meta: {
            keepAlive: false,
            title: '',
          },
          query: {},
        });
        this.$router.push({ path: '/receivablesAndPayables/payableList' });
      },
      //保存提交时计算明细行中所有的抵扣原币金额
      countLineDetaisDeductAll() {
        let lineDetailsDeductALL = 0;
        for (let mapData of this.settleAccountsDetailMap.values()) {
          for (const item of mapData) {
            lineDetailsDeductALL += +item['deductionOriginalAmount'];
          }
        }
        return lineDetailsDeductALL.toFixed(2);
      },
      //判断结算行中如果原币结算单价(含税)、结算数量以及明细行为空 时报错
      checkFalse() {
        let lines = this._formatSettleAccountDto();
        let checkStatus = false;
        if (lines && lines.length) {
          for (let index = 0; index < lines.length; index++) {
            const item = lines[index];
            console.log(item);
            if (!item.lineDetails?.length && !item.originalPrice && !item.settlementQuantity) {
              checkStatus = true;
              break;
            }
          }
        }
        if (checkStatus) {
          return true;
        }
      },
      //编辑时记录删除了哪些预结算单的id并回传给后端
      rememberDeleteRelatedIds() {
        let nowIds = [];
        let deleteIds = [];
        if (this.preSettlements.length > 0) {
          this.preSettlements.map((item) => {
            nowIds.push(item?.payableSettlementNo);
          });
        }
        if (this.copyPreSettlements.length > 0) {
          let deleteList = this.copyPreSettlements.filter(
            (item) => !nowIds.includes(item?.payableSettlementNo)
          );
          if (deleteList.length > 0) {
            deleteList.map((item) => {
              deleteIds.push(item.payableSettlementNo);
            });
          }
        }
        return deleteIds;
      },
      //编辑时记录删除了哪些预付款的id并回传给后端
      rememberDeletePayIds() {
        let nowIds = [];
        let deleteIds = [];
        if (this.advancePayments.length > 0) {
          this.advancePayments.map((item) => {
            nowIds.push(item?.id);
          });
        }
        if (this.copyAdvancePayments.length > 0) {
          let deleteList = this.copyAdvancePayments.filter((item) => !nowIds.includes(item?.id));
          if (deleteList.length > 0) {
            deleteList.map((item) => {
              deleteIds.push(item.id);
            });
          }
        }
        return deleteIds;
      },

      // 组装结算行结算明细数据给后端
      _formatSettleAccountDto() {
        const settleAccountList = [];
        this.lineDetailsList = [];
        this.settleAccountsRowList.map((item, index) => {
          const lineDetails = this.settleAccountsDetailMap.get(item._XID);
          if (!(lineDetails && lineDetails.length)) {
            this.noLineDetails = true; //判断每个结算行至少要对应一个结算明细
            this.settlementIndex = +index + 1;
          }
          this.lineDetailsList = this.lineDetailsList.concat(lineDetails || []);
          settleAccountList.push({
            ...item,
            additional: item.additional ? 1 : 2,
            lineDetails: lineDetails ? lineDetails : [],
          });
        });
        return settleAccountList;
      },
      // 计算原币金额和本币金额到表单中
      _computeRowTableTotalAmount(tableData) {
        let originalTotalAmount = 0;
        let domesticTotalAmount = 0;
        let originalTotalAmountWithoutTax = 0;
        let originalTotalTaxAmount = 0;
        let domesticTotalAmountWithoutTax = 0;
        let domesticTotalTaxAmount = 0;
        for (const item of tableData) {
          // originalTotalAmount += +item['originalAmount'];
          // domesticTotalAmount += +item['domesticAmount'];
          originalTotalAmount += +item['originalPracticalSettlementAmount'];
          domesticTotalAmount += +item['domesticPracticalSettlementAmount'];

          originalTotalAmountWithoutTax += +item['originalPracticalAmountWithoutTax'];
          originalTotalTaxAmount += +item['originalTaxAmount'];
          domesticTotalAmountWithoutTax += +item['domesticPracticalAmountWithoutTax'];
          domesticTotalTaxAmount += +item['domesticTaxAmount'];
        }
        this.countRelatedPriceALL(this.preSettlements, originalTotalAmount, domesticTotalAmount);
        // // 原币金额不含税 原币税额  本币金额不含税 本币税额赋值给表单
        this.baseFormData = {
          ...this.baseFormData,
          originalTotalAmountWithoutTax: originalTotalAmountWithoutTax.toFixed(2) + '',
          originalTotalTaxAmount: originalTotalTaxAmount.toFixed(2) + '',
          domesticTotalAmountWithoutTax: domesticTotalAmountWithoutTax.toFixed(2) + '',
          domesticTotalTaxAmount: domesticTotalTaxAmount.toFixed(2) + '',
        };
      },
      //关联预结算单原币结算金额 和本币结算金额 加上结算行里的原币结算金额 和本币结算金额 赋值到表单
      countRelatedPriceALL(tableData, originalTotalAmount, domesticTotalAmount) {
        let relatedOriginalTotalAmount = 0;
        let relatedDomesticTotalAmount = 0;
        for (const item of tableData) {
          relatedOriginalTotalAmount += +item['originalTotalAmount'];
          relatedDomesticTotalAmount += +item['domesticTotalAmount'];
        }
        // 赋值给表单
        this.baseFormData = {
          ...this.baseFormData,
          originalTotalAmount:
            (
              originalTotalAmount +
              relatedOriginalTotalAmount -
              (this.deductions[0]?.deductionOriginalAmount ?? 0)
            ).toFixed(2) + '',
          domesticTotalAmount:
            (
              domesticTotalAmount +
              relatedDomesticTotalAmount -
              (this.deductions[0]?.deductionDomesticAmount ?? 0)
            ).toFixed(2) + '',
        };
      },
      // 计算明细表中的原币金额和本币金额反填到结算表中
      _computedDetailTableTotalAmount(tableData, isNew = false) {
        console.log(tableData, 'tableData111111111111');
        if (tableData && tableData.length) {
          let domesticAmount = new Big(0);
          let originalAmount = new Big(0);
          let originalAmountWithoutTax = new Big(0);
          let originalTaxAmount = new Big(0);
          let domesticAmountWithoutTax = new Big(0);
          let domesticTaxAmount = new Big(0);
          let settlementQuantityTotal = new Big(0); // 结算数量
          for (const item of tableData) {
            originalAmount = originalAmount.plus(item['originalAmount']);
            domesticAmount = domesticAmount.plus(item['domesticAmount']);
            settlementQuantityTotal = settlementQuantityTotal.plus(item['settlementQuantity']);
            originalAmountWithoutTax = originalAmountWithoutTax.plus(
              item['originalAmountWithoutTax']
            );
            originalTaxAmount = originalTaxAmount.plus(item['originalTaxAmount']);
            domesticAmountWithoutTax = domesticAmountWithoutTax.plus(
              item['domesticAmountWithoutTax']
            );
            domesticTaxAmount = domesticTaxAmount.plus(item['domesticTaxAmount']);
          }
          let businessDocNoList = [...new Set(tableData.map((it) => it.businessDocNo))];
          let businessDocNo = businessDocNoList.length > 1 ? '' : businessDocNoList[0];
          const originalPriceList = tableData.map((item) => item.originalPrice);
          const originalPrice =
            [...new Set(originalPriceList)].length > 1 ? '' : originalPriceList[0];
          const unitList = tableData.map((item) => item.unit);
          const unit = [...new Set(unitList)].length > 1 ? '' : unitList[0]; // 单位
          const settlementQuantity =
            [...new Set(unitList)].length > 1 ? '' : settlementQuantityTotal.toFixed(8);
          console.log(originalPrice, unit, settlementQuantity, '---->>');
          // 给第一个表格赋值
          this.currentDetailData = {
            domesticAmount: domesticAmount.toFixed(2) + '',
            originalAmount: originalAmount.toFixed(2) + '',
            originalPrice,
            settlementQuantity,
            additional: '',
            businessDocNo,
            unit,
            unitName: this.dictListMap.basic_unit.find((val) => val.value == unit)?.label,
            originalAmountWithoutTax: originalAmountWithoutTax.toFixed(2) + '',
            originalTaxAmount: originalTaxAmount.toFixed(2) + '',
            domesticAmountWithoutTax: domesticAmountWithoutTax.toFixed(2) + '',
            domesticTaxAmount: domesticTaxAmount.toFixed(2) + '',
            _XID: isNew ? null : this.currentSettleAccountRowData._XID, // 当前行
          };
        }
      },
      //新增时将关联预结算中原币结算金额 和本币结算金额 累加到基本信息中
      countPriceHandler(
        tableData,
        originalAmount,
        domesticAmount,
        originalAmountWithoutTax,
        domesticAmountWithoutTax
      ) {
        console.log(tableData, 'tableDatahahhhah');
        let originalTotalAmount = 0;
        let domesticTotalAmount = 0;
        let originalTotalAmountWithoutTax = 0;
        let domesticTotalAmountWithoutTax = 0;
        let paidAmount = 0;
        if (tableData?.length > 0) {
          for (const item of tableData) {
            originalTotalAmount += +item['originalTotalAmount'];
            domesticTotalAmount += +item['domesticTotalAmount'];
            originalTotalAmountWithoutTax += +item['originalTotalAmountWithoutTax'];
            domesticTotalAmountWithoutTax += +item['domesticTotalAmountWithoutTax'];
            paidAmount += +item['paidAmount'];
          }
        }
        console.log(originalTotalAmount, '9999看看', domesticTotalAmount);

        let amount1 = Number(this.baseFormData.paidAmount);
        if (isNaN(amount1)) {
          amount1 = 0;
        }
        if (isNaN(paidAmount)) {
          paidAmount = 0;
        }
        // 赋值给表单
        this.baseFormData = {
          ...this.baseFormData,
          originalTotalAmount: (+originalAmount + originalTotalAmount).toFixed(2) + '',
          domesticTotalAmount: (+domesticAmount + domesticTotalAmount).toFixed(2) + '',
          originalTotalAmountWithoutTax:
            (+originalAmountWithoutTax + originalTotalAmountWithoutTax).toFixed(2) + '',
          domesticTotalAmountWithoutTax:
            (+domesticAmountWithoutTax + domesticTotalAmountWithoutTax).toFixed(2) + '',
          paidAmount: (+amount1 + +paidAmount).toFixed(2),
        };
      },
      //关联预结算删除时将基本信息中原币结算金额 和本币结算金额减去 删除行中的原币结算金额 和本币结算金额
      subtractPriceHandler(
        tableData,
        originalAmount,
        domesticAmount,
        originalAmountWithoutTax,
        domesticAmountWithoutTax
      ) {
        let originalTotalAmount = 0;
        let domesticTotalAmount = 0;
        let originalTotalAmountWithoutTax = 0;
        let domesticTotalAmountWithoutTax = 0;
        let paidAmount = 0;
        for (const item of tableData) {
          originalTotalAmount += +item['originalTotalAmount'];
          domesticTotalAmount += +item['domesticTotalAmount'];
          originalTotalAmountWithoutTax += +item['originalTotalAmountWithoutTax'];
          domesticTotalAmountWithoutTax += +item['domesticTotalAmountWithoutTax'];
          paidAmount += +item['paidAmount'];
        }
        // 赋值给表单
        this.baseFormData = {
          ...this.baseFormData,
          originalTotalAmount: (+originalAmount - originalTotalAmount).toFixed(2) + '',
          domesticTotalAmount: (+domesticAmount - domesticTotalAmount).toFixed(2) + '',
          originalTotalAmountWithoutTax:
            (+originalAmountWithoutTax - originalTotalAmountWithoutTax).toFixed(2) + '',
          domesticTotalAmountWithoutTax:
            (+domesticAmountWithoutTax - domesticTotalAmountWithoutTax).toFixed(2) + '',
          paidAmount: (+this.baseFormData.paidAmount - +paidAmount).toFixed(2),
        };
      },

      //关联预结算单的删除
      deleteRelatedTableHandler(rowIdList, selectionList) {
        this.preSettlements = this.preSettlements.filter((item) => !rowIdList.includes(item.id));
        this.subtractPriceHandler(
          selectionList,
          this.baseFormData.originalTotalAmount,
          this.baseFormData.domesticTotalAmount,
          this.baseFormData.originalTotalAmountWithoutTax,
          this.baseFormData.domesticTotalAmountWithoutTax
        );
        // console.log(rowIdList, 'xIDList');
        // console.log(selectionList, 'selectionList');
        console.log(this.preSettlements, 'this.preSettlements');
      },
      //关联预结算弹窗关闭时一系列操作
      relatedHandler(val) {
        console.log(val, '关联值');
        // let copyPreSettlements = JSON.parse(JSON.stringify(this.preSettlements));
        // let mergeList = this.removeDp(copyPreSettlements.concat(val));
        let payableSettlementNoList = [];
        if (this.preSettlements.length > 0) {
          this.preSettlements.map((item) => {
            payableSettlementNoList.push(item.payableSettlementNo);
          });
        }
        if (val.length > 0) {
          let newList = val.filter(
            (item) => !payableSettlementNoList.includes(item.payableSettlementNo)
          );
          this.countPriceHandler(
            newList,
            this.baseFormData.originalTotalAmount,
            this.baseFormData.domesticTotalAmount,
            this.baseFormData.originalTotalAmountWithoutTax,
            this.baseFormData.domesticTotalAmountWithoutTax
          );
          this.preSettlements = [...this.preSettlements, ...newList];
          console.log(this.preSettlements, 'this.preSettlements');
        }
        // if (mergeList.length > this.preSettlements.length) {
        //   let newList = mergeList.filter((item, index) => {
        //     return item.payableSettlementNo !== this.preSettlements[index]?.payableSettlementNo;
        //   });
        //   this.countPriceHandler(
        //     newList,
        //     this.baseFormData.originalTotalAmount,
        //     this.baseFormData.domesticTotalAmount
        //   );
        //   this.preSettlements = [...this.preSettlements, ...newList];
        //   console.log(this.preSettlements, 'this.preSettlements');
        // }
        // console.log(mergeList, '合并数据');
      },
      removeDp(tableData) {
        let temp = {}; //	用于payableSettlementNo判断
        let result = []; // 最后的新数组
        tableData.map((item) => {
          if (!temp[item.payableSettlementNo]) {
            result.push(item);
            temp[item.payableSettlementNo] = true;
          }
        });
        return result;
      },

      // 根据id来查下数据
      async _getDetailDataById(payNo) {
        if (!payNo) return;
        this.loading.startLoading();
        const { data } = await this.$axios.post(
          `${PAYABLES_TRADE.GET_PAYBLES_SETTLEMENT_DETAIL_BY_NO}/${payNo}`
        );
        console.log(data, 'data');
        if (data.code == 0) {
          this.detailData = data.data;
          console.log(JSON.stringify(this.detailData), '???');
          if (this.detailData.supplyDetailsAttachments.length) {
            const pdfFile = {};
            pdfFile.specialFile = 'special'; //特殊查看pdf
            pdfFile.attachmentPath1 = this.detailData.supplyDetailsAttachments[1].attachmentPath;
            let specialFile = Object.assign(
              {},
              this.detailData.supplyDetailsAttachments[0],
              pdfFile
            );
            // this.detailData.attachments.push(specialFile);
            if (!this.detailData.attachments.some((item) => item.id === specialFile.id)) {
              this.detailData.attachments.push(specialFile);
            }
          }
          console.log(this.detailData);
          this.loading.endLoading();
          this.noMust = this.baseFormData.supplierNo.split(',').length <= 1 ? true : false;
          // 单独抽取表单数据
          const {
            payableSettlementNo,
            settlementCompanyNo,
            settlementCompanyName,
            settlementDepartmentNo,
            settlementDepartmentName,
            isMoreDeliverer,
            supplierNo,
            supplierName,
            orderNo,
            contractNo,
            originalTotalAmount,
            domesticTotalAmount,
            originalTotalAmountWithoutTax,
            originalTotalTaxAmount,
            domesticTotalAmountWithoutTax,
            domesticTotalTaxAmount,
            payableAccountPeriod,
            settlementDate,
            settlementStatus,
            paymentStatus,
            paidAmount,
            unpaidAmount,
            anotherPayFlag,
            anotherPayPlatform,
            settlementCenter,
            settlementCenterName,
            settlementType,
            settlementBusinessType,
            projectInitiationNo,
            projectName,
            exchangeDate,
            exchangeRate,
            currencyCode,
            currencyName,
            salesmanName,
            salesmanNo,
            settlementCreateDate,
            payPayableSettlementNo,
            printFlag,
            remark,
            signetType,
          } = data.data;
          this.baseFormData = {
            payableSettlementNo,
            settlementCompanyNo,
            settlementCompanyName,
            settlementDepartmentNo,
            settlementDepartmentName,
            isMoreDeliverer: isMoreDeliverer + '',
            supplierNo,
            supplierName,
            orderNo,
            contractNo: contractNo + '',
            originalTotalAmount: originalTotalAmount ? originalTotalAmount + '' : '0',
            domesticTotalAmount: domesticTotalAmount ? domesticTotalAmount + '' : '0',
            originalTotalAmountWithoutTax: originalTotalAmountWithoutTax
              ? originalTotalAmountWithoutTax + ''
              : '0',
            originalTotalTaxAmount: originalTotalTaxAmount ? originalTotalTaxAmount + '' : '0',
            domesticTotalAmountWithoutTax: domesticTotalAmountWithoutTax
              ? domesticTotalAmountWithoutTax + ''
              : '0',
            domesticTotalTaxAmount: domesticTotalTaxAmount ? domesticTotalTaxAmount + '' : '0',
            payableAccountPeriod,
            settlementDate,
            settlementStatus,
            paymentStatus,
            paidAmount: paidAmount ? paidAmount + '' : '0',
            unpaidAmount: unpaidAmount ? unpaidAmount + '' : '0',
            anotherPayFlag: anotherPayFlag === 0 ? false : true,
            anotherPayPlatform,
            settlementCenter,
            settlementCenterName,
            settlementType,
            settlementBusinessType,
            projectInitiationNo,
            projectName,
            exchangeDate,
            exchangeRate: exchangeRate ? exchangeRate + '' : '1',
            currencyCode,
            currencyName,
            salesmanName,
            salesmanNo,
            settlementCreateDate,
            printFlag: printFlag === 0 ? false : true,
            payPayableSettlementNo: payPayableSettlementNo || null,
            remark,
            signetType,
          };
          this.statementStatus = settlementStatus;
          this.statePaymentStatus = paymentStatus;
          //关联预结算
          this.preSettlements = data.data.preSettlements || [];
          this.copyPreSettlements = JSON.parse(JSON.stringify(this.preSettlements));
          //抵扣信息
          this.deductions = data.data.deductions || [];
          //关联预付款
          this.advancePayments = data.data.advancePayments || [];
          this.copyAdvancePayments = JSON.parse(JSON.stringify(this.advancePayments));
          //用于记录已付款金额 后续重新选择合同有用
          this.copyPaidAmount = paidAmount || '0';
          // 反填部门信息
          this._getDepartmentByCompanyCodeApi(settlementCompanyNo);
          this._getPaymentTablelistData(this.$route.query?.payNo);
          //根据公司部门下的合同获取商品
          if (
            this.baseFormData.supplierNo.split(',').length <= 1 &&
            this.baseFormData.contractNo.split(',').length <= 1
          ) {
            this._getContractProduct(settlementCompanyNo, settlementDepartmentNo, contractNo);
          }
        } else {
          this.$message.error('获取数据失败');
        }
      },
      async _getContractProduct(companyCode, departmentCode, contractNo) {
        const postData = {
          contractBusinessCompanyNo: companyCode,
          contractBusinessDepartment: departmentCode,
          exactContractNo: contractNo,
          contractCategory: 'purchase',
          contractDetailCategory: 'CG01',
        };
        this.productList = [];
        const { data } = await this.$axios.post(SALE_API.STATEMENT_CONTRACT_LIST_API, postData);
        if (data.code == 0) {
          let orderDetailList = data.data[0].orderDetailList;
          if (orderDetailList.length) {
            orderDetailList.map((item) => {
              if (item.productDesc && item.productNo) {
                this.productList.push({
                  label: item.productDesc,
                  value: item.productNo,
                  contractDetailId: item.id,
                  taxRate: item.taxRate,
                });
              }
            });
          }
        }
      },
      async _getPaymentTablelistData(payNo) {
        if (!payNo) return;
        const postData = { payableSettlementNo: payNo };
        const { data } = await this.$axios.post(
          PAYABLES_TRADE.GET_PAYBLES_PAYMENT_INFORMATION_BY_NO,
          postData
        );
        if (data.code == 0) {
          this.payeeInfoData = data.data || [];
          // let payAll = 0;
          // if (data.data.length > 0) {
          //   for (const item of data.data) {
          //     payAll += +item['paidAmount'];
          //   }
          // }
          // // 赋值给表单
          // this.baseFormData = {
          //   ...this.baseFormData,
          //   paidAmount: payAll + '',
          //   unpaidAmount: this.baseFormData.originalTotalAmount - payAll + '',
          // };
        } else {
          this.$message.error('获取数据失败');
        }
        console.log(data, '付款信息');
      },
      //费用清单过来获取基本信息以及明细行
      async _getBaseformData(ids) {
        if (ids.length < 1) return;
        this.loading.startLoading();
        const postData = { ids };
        const { data } = await this.$axios.post(
          PAYABLES_TRADE.GET_PAYBLES_BASEFORMDATA_BY_IDS,
          postData
        );
        console.log(data, '基本信息');
        if (data.code == 0) {
          this.loading.endLoading();
          // 单独抽取表单数据
          let contractNoList = data.data.map((item) => item.contractNo);
          // this.contractNos = contractNoList;
          let supplierNoList = data.data.map((item) => item.supplierNo);
          let isMoreDeliverer = [...new Set(supplierNoList)].length > 1 ? '1' : '0';
          let supplierNo = [...new Set(supplierNoList)].join(',');
          let supplierNameList = data.data.map((item) => item.supplierName);
          let supplierName = [...new Set(supplierNameList)].join(',');
          let contractNo = [...new Set(contractNoList)].join(','); // 合同,
          // this.noMust = [...new Set(contractNoList)].length > 1 ? false : true;

          console.log(contractNoList, 'contractNoList');
          const {
            settlementNo,
            businessCompanyNo,
            businessCompanyName,
            businessDepartmentCode,
            businessDepartmentName,
            // supplierNo,
            // supplierName,
            businessDocCode,
            // contractNo,
            originalAmount,
            domesticAmount,
            accountPeriod,
            periodDateUntil,
            settlementStatus,
            paymentStatus,
            paidAmount,
            unpaidAmount,
            anotherPayPlatform,
            // settlementCenter,
            projectInitiationNo,
            projectName,
            // exchangeDate,
            exchangeRate,
            currencyCode,
            currencyName,
            remark,
            // signetType,
          } = data.data[0];

          let settlementCenter = data.data[0].settlementCenter;
          let settlementCenterName = data.data[0].settlementCenterName;

          if (this.userInfo.companyCode != 'OAC20') {
            settlementCenter = this.userInfo.companyCode;
            settlementCenterName = this.userInfo.companyName;
          }

          this.baseFormData = {
            payableSettlementNo: settlementNo,
            settlementCompanyNo: businessCompanyNo,
            settlementCompanyName: businessCompanyName,
            settlementDepartmentNo: businessDepartmentCode,
            settlementDepartmentName: businessDepartmentName,
            isMoreDeliverer,
            supplierNo,
            supplierName,
            orderNo: businessDocCode,
            contractNo: contractNo,
            originalTotalAmount: originalAmount ? originalAmount + '' : '0',
            domesticTotalAmount: domesticAmount ? domesticAmount + '' : '0',
            payableAccountPeriod: accountPeriod,
            settlementDate: periodDateUntil,
            settlementStatus,
            paymentStatus,
            paidAmount: paidAmount ? paidAmount + '' : '0',
            unpaidAmount: unpaidAmount ? unpaidAmount + '' : '0',
            anotherPayFlag: false,
            anotherPayPlatform,
            settlementCenter,
            settlementCenterName,
            settlementType: '',
            settlementBusinessType: '05',
            projectInitiationNo,
            projectName,
            exchangeDate: formatDate(new Date()),
            exchangeRate: exchangeRate ? exchangeRate + '' : '1',
            currencyCode,
            currencyName,
            salesmanNo: this.userInfo.personNo,
            salesmanName: this.userInfo.personName,
            settlementCreateDate: formatDate(new Date()),
            printFlag: false,
            payPayableSettlementNo: null,
            remark,
          };
          // 初始化审批方式
          this.initSignetType();
          //用于记录已付款金额 后续重新选择合同有用
          this.copyPaidAmount = paidAmount || '0';
          // 反填部门信息
          this._getDepartmentByCompanyCodeApi(businessCompanyNo);
          //根据公司部门下的合同获取商品
          // console.log(this.baseFormData.supplierNo.split(','), 'supplierNo6666666666');
          // console.log(this.baseFormData.contractNo.split(','), 'supplierNo9999999999');
          if (
            this.baseFormData.supplierNo.split(',').length <= 1 &&
            this.baseFormData.contractNo.split(',').length <= 1
          ) {
            this._getContractProduct(businessCompanyNo, businessDepartmentCode, contractNo);
          }

          this.assembleHandler(data.data);
          console.log(data, '基本信息');
        }
      },
      //将行明细组装成行信息
      assembleHandler(tableData) {
        console.log(tableData, '费用清单创建tableData');
        let domesticAmount = 0;
        let originalAmount = 0;
        let originalTotalAmountWithoutTax = 0;
        let originalTotalTaxAmount = 0;
        let domesticTotalAmountWithoutTax = 0;
        let domesticTotalTaxAmount = 0;
        let paidAmountTotal = 0;
        tableData.forEach((item) => {
          item.deductionOriginalAmount = '';
          item.deductionDomesticAmount = '';
          item.settlementQuantity = item.statementQuantity;
          item.businessDocNo = item.businessDocCode;
          item.inboundDate = item.businessDate;
          item.originalAmount = item.originalAmount.toFixed(2);
          item.domesticAmount = item.domesticAmount.toFixed(2);
          item.originalAmountWithoutTax = (item.originalAmount / (1 + +item.taxRate)).toFixed(2);
          item.originalTaxAmount = (item.originalAmount - item.originalAmountWithoutTax).toFixed(2);
          item.domesticAmountWithoutTax = (item.domesticAmount / (1 + +item.taxRate)).toFixed(2);
          item.domesticTaxAmount = (item.domesticAmount - item.domesticAmountWithoutTax).toFixed(2);
          item.exchangeRate = item.exchangeRate || 1;
          item.originalPrice = item.originalPrice.toFixed(8);
          item.unitName = this.dictListMap.basic_unit.find((val) => val.value == item.unit)?.label;
          originalAmount += +item['originalAmount'];
          domesticAmount += +item['domesticAmount'];
          paidAmountTotal += +item['paidAmount'] || 0;

          originalTotalAmountWithoutTax += +item['originalAmountWithoutTax'];
          originalTotalTaxAmount += +item['originalTaxAmount'];
          domesticTotalAmountWithoutTax += +item['domesticAmountWithoutTax'];
          domesticTotalTaxAmount += +item['domesticTaxAmount'];
        });
        let dataMap = this.classificationHandler(tableData);
        let lines = [];
        for (const key in dataMap) {
          const currentItemList = dataMap[key].item; // 同一类供应商
          const currentUnit = [...new Set(currentItemList.map((it) => it.unit))];
          const unit = currentUnit.length > 1 ? '' : currentUnit[0]; // 单位
          const originalPriceList = [...new Set(currentItemList.map((it) => it.originalPrice))];
          let domesticAmount = 0;
          let originalAmount = 0;
          let settlementQuantityTotal = 0; // 数量
          for (const item of currentItemList) {
            originalAmount += +item['originalAmount'];
            domesticAmount += +item['domesticAmount'];
            settlementQuantityTotal += +item['statementQuantity'];
          }
          let settlementQuantity = currentUnit.length > 1 ? '' : settlementQuantityTotal.toFixed(8);
          let productNameList = [...new Set(currentItemList.map((it) => it.productName))];
          let productCodeList = [...new Set(currentItemList.map((it) => it.productCode))];
          let productName = productNameList.length > 1 ? '' : productNameList[0];
          let productCode = productCodeList.length > 1 ? '' : productCodeList[0];
          let goodsCategoryNameList = [
            ...new Set(currentItemList.map((it) => it.goodsCategoryName)),
          ];
          let goodsCategoryCodeList = [
            ...new Set(currentItemList.map((it) => it.goodsCategoryCode)),
          ];
          let goodsCategoryName = goodsCategoryNameList.length > 1 ? '' : goodsCategoryNameList[0];
          let goodsCategoryCode = goodsCategoryCodeList.length > 1 ? '' : goodsCategoryCodeList[0];
          let businessNameList = [...new Set(currentItemList.map((it) => it.businessName))];
          let productModelList = [...new Set(currentItemList.map((it) => it.productModel))];
          let businessName = businessNameList.length > 1 ? '' : businessNameList[0];
          let productModel = productModelList.length > 1 ? '' : productModelList[0];
          let businessDocNoList = [...new Set(currentItemList.map((it) => it.businessDocNo))];
          let businessDocNo = businessDocNoList.length > 1 ? '' : businessDocNoList[0];

          lines.push({
            settlementDesc: '',
            originalPrice: originalPriceList.length > 1 ? '' : originalPriceList[0],
            settlementQuantity,
            originalAmount: originalAmount.toFixed(2),
            currencyCode: currentItemList[0].currencyCode,
            currencyName: currentItemList[0].currencyName,
            contractNo: currentItemList[0].contractNo,
            exchangeRate: currentItemList[0].exchangeRate ? currentItemList[0].exchangeRate : 1,
            domesticAmount: domesticAmount.toFixed(2),
            additional: '',
            businessName,
            supplierName: currentItemList[0].supplierName,
            supplierNo: currentItemList[0].supplierNo,
            businessDocNo,
            unit,
            unitName: unit
              ? this.dictListMap.basic_unit.find((val) => val.value == unit)?.label
              : '',
            productName,
            productCode,
            goodsCategoryName,
            goodsCategoryCode,
            productModel,
            originalAmountWithoutTax: currentItemList
              .reduce((pre, next) => pre + +next.originalAmountWithoutTax, 0)
              .toFixed(2),
            originalTaxAmount: currentItemList
              .reduce((pre, next) => pre + +next.originalTaxAmount, 0)
              .toFixed(2),
            domesticAmountWithoutTax: currentItemList
              .reduce((pre, next) => pre + +next.domesticAmountWithoutTax, 0)
              .toFixed(2),
            domesticTaxAmount: currentItemList
              .reduce((pre, next) => pre + +next.domesticTaxAmount, 0)
              .toFixed(2),
            deductAmount: 0,
            originalPracticalSettlementAmount: currentItemList
              .reduce((pre, next) => pre + +next.originalAmount, 0)
              .toFixed(2),
            originalPracticalAmountWithoutTax: currentItemList
              .reduce((pre, next) => pre + +next.originalAmountWithoutTax, 0)
              .toFixed(2),
            domesticPracticalSettlementAmount: currentItemList
              .reduce((pre, next) => pre + +next.domesticAmount, 0)
              .toFixed(2),
            domesticPracticalAmountWithoutTax: currentItemList
              .reduce((pre, next) => pre + +next.domesticAmountWithoutTax, 0)
              .toFixed(2),
            remark: '',
            id: currentItemList[0].id,
            lineDetails: currentItemList,
          });
        }

        this.detailData = { lines };
        // 赋值给表单
        this.baseFormData = {
          ...this.baseFormData,
          originalTotalAmount: originalAmount.toFixed(2) + '',
          domesticTotalAmount: domesticAmount.toFixed(2) + '',
          originalTotalAmountWithoutTax: originalTotalAmountWithoutTax.toFixed(2) + '',
          originalTotalTaxAmount: originalTotalTaxAmount.toFixed(2) + '',
          domesticTotalAmountWithoutTax: domesticTotalAmountWithoutTax.toFixed(2) + '',
          domesticTotalTaxAmount: domesticTotalTaxAmount.toFixed(2) + '',
          paidAmount: paidAmountTotal + '',
        };
      },
      // classificationHandler(dataList) {
      //   let newMap = {};
      //   for (const item of dataList) {
      //     const isExist = newMap[item.delivererNo];
      //     if (isExist) {
      //       isExist.push(item);
      //       newMap[item.delivererNo] = isExist;
      //     } else {
      //       let list1 = new Array();
      //       list1.push(item);
      //       newMap[item.delivererNo] = list1;
      //     }
      //   }
      //   // console.log(newMap, '分类处理');
      //   return newMap;
      // },
      classificationHandler(arr) {
        let map = [
          {
            delivererNo: arr[0].delivererNo,
            contractNo: arr[0].contractNo,
            productCode: arr[0].productCode,
            item: [arr[0]],
          },
        ];
        for (let i = 1; i < arr.length; i++) {
          let bool = map.some((it) => {
            if (
              arr[i].delivererNo == it.delivererNo &&
              arr[i].contractNo == it.contractNo &&
              arr[i].productCode == it.productCode
            ) {
              it['item'].push(arr[i]);
            }
            return (
              arr[i].delivererNo == it.delivererNo &&
              arr[i].contractNo == it.contractNo &&
              arr[i].productCode == it.productCode
            );
          });
          if (!bool) {
            map.push({
              delivererNo: arr[i].delivererNo,
              contractNo: arr[i].contractNo,
              productCode: arr[i].productCode,
              item: [arr[i]],
            });
          }
        }
        for (const it of map) {
          console.log(it, 'of循环map');
        }
        for (const it in map) {
          console.log(map[it].item, 'in循环map');
        }
        console.log(map, '分类处理');
        return map;
      },
      //关联预结算按钮
      btnRelatedHandler() {
        if (this.baseFormData.supplierNo.split(',').length > 1) {
          this.$message.warning('该结算单存在多个供应商不能发起关联预结算操作');
          return;
        }

        if (!this.baseFormData.supplierNo || !this.baseFormData.contractNo) {
          this.$message.warning('请选择供应商和合同编号');
          return;
        }

        const { supplierNo, contractNo, supplierName } = this.baseFormData;
        this.$refs.relatedSettlementRef.query.supplierNo = supplierNo;
        this.$refs.relatedSettlementRef.query.contractNoStr = contractNo;
        this.$refs.relatedSettlementRef.query.supplierName = supplierName;
        this.$refs.relatedSettlementRef.openDialog();
      },
      //抵扣按钮
      _btnDeductionHandler() {
        if (this.advancePayments && this.advancePayments.length) {
          this.$message.warning('该结算单存在预付款不能发起抵扣操作');
          return;
        }
        if (this.baseFormData.supplierNo.split(',').length > 1) {
          this.$message.warning('该结算单存在多个供应商不能发起抵扣操作');
          return;
        }

        if (!this.baseFormData?.supplierNo || !this.baseFormData?.contractNo) {
          this.$message.warning('请选择供应商和合同编号');
          return;
        }

        const { supplierNo, contractNo, supplierName, originalTotalAmount } = this.baseFormData;
        this.$refs.deductionDialogRef.query.payeeNo = supplierNo;
        this.$refs.deductionDialogRef.query.purchaseOrderNoStr = contractNo;
        this.$refs.deductionDialogRef.query.payeeName = supplierName;
        this.$refs.deductionDialogRef.outerOriginalTotalAmount = originalTotalAmount;
        this.$refs.deductionDialogRef.openDialog();
      },
      //抵扣弹窗关闭操作
      deductionDialogHandler(deductList, deductAll) {
        if (this.deductions && this.deductions.length) {
          this.deleteDeductionId = this.deductions[0]?.id || this.deleteDeductionId;
        }
        const {
          currencyCode,
          currencyName,
          exchangeRate,
          originalTotalAmount,
          domesticTotalAmount,

          originalTotalAmountWithoutTax,
          domesticTotalAmountWithoutTax,
        } = this.baseFormData;
        let deductTableData = this.$refs?.DeductionRow?.getTableData();
        if (deductTableData && deductTableData?.length) {
          const { deductionOriginalAmount, deductionDomesticAmount } = deductTableData[0];
          // 赋值给表单
          this.baseFormData = {
            ...this.baseFormData,
            originalTotalAmount:
              (+originalTotalAmount + +deductionOriginalAmount - deductAll).toFixed(2) + '',
            domesticTotalAmount:
              (+domesticTotalAmount + +deductionDomesticAmount - deductAll * exchangeRate).toFixed(
                2
              ) + '',

            originalTotalAmountWithoutTax:
              (+originalTotalAmountWithoutTax + +deductionOriginalAmount - deductAll).toFixed(2) +
              '',
            domesticTotalAmountWithoutTax:
              (
                +domesticTotalAmountWithoutTax +
                +deductionDomesticAmount -
                deductAll * exchangeRate
              ).toFixed(2) + '',
          };
        } else {
          // 赋值给表单
          this.baseFormData = {
            ...this.baseFormData,
            originalTotalAmount: (+originalTotalAmount - deductAll).toFixed(2) + '',
            domesticTotalAmount: (+domesticTotalAmount - deductAll * exchangeRate).toFixed(2) + '',

            originalTotalAmountWithoutTax:
              (+originalTotalAmountWithoutTax - deductAll).toFixed(2) + '',
            domesticTotalAmountWithoutTax:
              (+domesticTotalAmountWithoutTax - deductAll * exchangeRate).toFixed(2) + '',
          };
        }
        this.deductions = [
          {
            deductionDesc: '',
            deductionOriginalAmount: deductAll,
            currencyName,
            currencyCode,
            exchangeRate,
            deductionDomesticAmount: (deductAll * exchangeRate).toFixed(2),
          },
        ];
        this.deductionDetails = deductList;
      },
      //编辑抵扣行
      closeEditDeductTableRowHandler(value) {
        this.deductions = value;
      },
      //删除抵扣行
      deleteDeductTableHandler(deleteDeductionId) {
        console.log(this.deductions, 'this.deductions');
        this.deleteDeductionId = deleteDeductionId || this.deleteDeductionId;
        const { deductionOriginalAmount, deductionDomesticAmount } = this.deductions[0];
        // 赋值给表单
        this.baseFormData = {
          ...this.baseFormData,
          originalTotalAmount: (
            +this.baseFormData.originalTotalAmount + +deductionOriginalAmount
          ).toFixed(2),
          domesticTotalAmount: (
            +this.baseFormData.domesticTotalAmount + +deductionDomesticAmount
          ).toFixed(2),

          originalTotalAmountWithoutTax: (
            +this.baseFormData.originalTotalAmountWithoutTax + +deductionOriginalAmount
          ).toFixed(2),
          domesticTotalAmountWithoutTax: (
            +this.baseFormData.domesticTotalAmountWithoutTax + +deductionDomesticAmount
          ).toFixed(2),
        };
        this.deductions = [];
      },
      //关联预付款
      _btnPayHandler() {
        if (this.deductions && this.deductions.length) {
          this.$message.warning('该结算单存在抵扣不能发起预付款操作');
          return;
        }
        if (this.baseFormData.supplierNo.split(',').length > 1) {
          this.$message.warning('该结算单存在多个供应商不能发起预付款操作');
          return;
        }

        if (!this.baseFormData.supplierNo || !this.baseFormData.contractNo) {
          this.$message.warning('请选择供应商和合同编号');
          return;
        }

        const { supplierNo, contractNo, supplierName, originalTotalAmount } = this.baseFormData;
        this.$refs.payDialogRef.query.payeeNo = supplierNo;
        this.$refs.payDialogRef.query.purchaseOrderNoStr = contractNo;
        this.$refs.payDialogRef.query.payeeName = supplierName;
        this.$refs.payDialogRef.outerOriginalTotalAmount = originalTotalAmount;
        this.$refs.payDialogRef.openDialog();
      },
      //关联预结算单的删除
      deletePayTableHandler(rowIdList, deleteList) {
        this.advancePayments = this.advancePayments.filter((item) => !rowIdList.includes(item.id));
        let paidAmountAll = deleteList.reduce((pre, next) => pre + +next.paidAmount, 0).toFixed(2);
        // 赋值给表单
        this.baseFormData = {
          ...this.baseFormData,
          paidAmount: (+this.baseFormData.paidAmount - +paidAmountAll).toFixed(2),
        };
        // console.log(rowIdList, 'xIDList');
        // console.log(selectionList, 'selectionList');
        console.log(this.preSettlements, 'this.preSettlements');
      },
      //关联预付款弹窗关闭时一系列操作
      payDialogHandler(val) {
        console.log(val, '关联值');

        let paymentApplyNumberList = [];
        if (this.advancePayments.length > 0) {
          this.advancePayments.map((item) => {
            paymentApplyNumberList.push(item.paymentApplyNumber);
          });
        }
        if (val.length > 0) {
          let newList = val.filter(
            (item) => !paymentApplyNumberList.includes(item.paymentApplyNumber)
          );

          this.advancePayments = [...this.advancePayments, ...newList];
          let paidAmountAll = this.advancePayments
            .reduce((pre, next) => pre + +next.paidAmount, 0)
            .toFixed(2);
          // 赋值给表单
          this.baseFormData = {
            ...this.baseFormData,
            paidAmount: (+this.baseFormData.paidAmount + +paidAmountAll).toFixed(2),
          };
          // console.log(paidAmountAll, 'paidAmountAll');
          // console.log(this.advancePayments, 'this.advancePayments');
        }
      },
    },

    mounted() {
      this.currentStatus = this.$route.query?.status; // 当前状态
      if (['edit', 'detail'].includes(this.$route.query?.status)) {
        this._getDetailDataById(this.$route.query?.payNo);
        // this._getPaymentTablelistData(this.$route.query?.payNo);
      }

      if (['create'].includes(this.$route.query?.status) && this.userInfo.companyCode != 'OAC20') {
        this.baseFormData.settlementCenter = this.userInfo.companyCode;
        this.baseFormData.settlementCenterName = this.userInfo.companyName;
      }
      if (['create'].includes(this.$route.query?.status) && this.$route.query?.id?.length > 0) {
        let ids = this.$route.query?.id;
        if (ids && Array.isArray(ids) && ids.length) {
          this._getBaseformData(ids);
        } else {
          this._getBaseformData([ids]);
        }
      }
    },
    components: {
      // BaseInfo,
      SettleAccountsRow,
      SettleAccountsInfo,
      DeductionRow,
      PayeeInfo,
      // FileTable,
      DeductionDialog,
      RelatedSettlement,
      RelatedRow,
      Print,
      PrintDemo,
      PrintDialog,
      PayRow,
      PayDialog,
    },
    computed: {
      btnList() {
        const allBtnList = [
          {
            title: '保存',
            type: 'save',
          },
          {
            title: '编辑',
            type: 'edit',
          },
          {
            title: '提交审批',
            type: 'approval',
          },
          {
            title: '付款申请',
            type: 'payApplication',
          },

          {
            title: '调整',
            type: 'resize',
          },
          {
            title: '撤回',
            type: 'cancel',
          },
          {
            title: '锁定',
            type: 'settlementLock',
          },
          {
            title: '关闭',
            type: 'close',
          },
          {
            title: '抵扣',
            type: 'deduction',
          },
          {
            title: '打印',
            type: 'print',
          },
        ];
        // statementStatus:01-保存,02-审批中,03-已驳回,04-已通过,05-已撤回,06-已锁定,07-已关闭
        // statePaymentStatus  01-已付款,02-未付款,03-部分付款
        //payeeInfoData  是否关联付款单   当payeeInfoData.length>0就关联了 否则未关联
        // if (['create'].includes(this.currentStatus)) {
        //   return allBtnList.filter((item) => ['save'].includes(item.type));
        // }
        // if (['edit'].includes(this.currentStatus)) {
        //   return allBtnList.filter((item) => ['save', 'approval'].includes(item.type));
        // }
        if (['detail'].includes(this.currentStatus)) {
          // if (['01', '03', '05'].includes(this.statementStatus)) {
          //   // 已经保存,已驳回,已撤回 this.isCreate
          //   return allBtnList.filter((item) => ['edit'].includes(item.type));
          // }
          //  else if (['01', '03', '05'].includes(this.statementStatus) && this.isCreate) {
          //   // 已经保存,已驳回,已撤回 this.isCreate
          //   return allBtnList.filter((item) => ['save', 'approval'].includes(item.type));
          // }
          // else
          if (this.statementStatus == '04') {
            if (this.payeeInfoData.length < 1) {
              return allBtnList.filter((item) =>
                ['payApplication', 'settlementLock', 'cancel', 'print'].includes(item.type)
              );
            } else if (
              this.payeeInfoData.length > 0 &&
              ['02', '03'].includes(this.statePaymentStatus)
            ) {
              return allBtnList.filter((item) => ['payApplication', 'print'].includes(item.type));
            } else if (this.payeeInfoData.length > 0 && ['01'].includes(this.statePaymentStatus)) {
              return allBtnList.filter((item) => ['close', 'print'].includes(item.type));
            } else {
              return [];
            }
          }
          // else if (['06'].includes(this.statementStatus) && this.payeeInfoData.length < 1) {
          //   return allBtnList.filter((item) => ['resize'].includes(item.type));
          // }
          else {
            return [];
          }
        } else {
          return [];
        }
        // return allBtnList;
      },
      // 是否隐藏付款信息
      isHiddenInfo() {
        return ['edit', 'detail'].includes(this.currentStatus);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .btn-group {
    padding: 20px 0px;
    box-sizing: border-box;
  }
</style>
